import './index.css'
import Button from '../button'
import { useState } from 'react'
import { onboardSites } from '../../functions/onboardSites'
import { createCustomPostFromURL } from '../../functions/createCustomPostFromURL'
import { updateICP } from '../../functions/updateICP'
import { updatePersona } from '../../functions/updatePersona'
import { updateRole } from '../../functions/updateRole'

function Onboarding() {
  const [input, setInput] = useState('')
  const [inputs, setInputs] = useState([])
  const [userType, setUserType] = useState('')
  const [persona, setPersona] = useState('')
  const [icp, setICP] = useState('')
  const [isError, SetIsError] = useState(false)
  const [errorStatus, SetErrorStatus] = useState('')
  const [onboardingState, SetOnboardingState] = useState(0);
  const prebuiltSites = {
    "Marketer":["socialmediatoday.com","lunio.ai","mostlymetrics.com"],
    "Founder":["saastr.com","thetwentyminutevc.com","techcrunch.com"],
    "Freelancer":["saastr.com","lunio.ai","socialmediatoday.com"]
  }

  const stateCopy = [
    {
      copy: `First up, how would you describe yourself?`,
    },
    {
      copy: `Now tell us a bit more about yourself.

What's your writing style? Are you fun and casual? Informative or serious? Confident or humble?

This is your *persona*, and it helps Mako better understand your voice.`,
      placeholder: 'Type your persona here...',
    },
    {
      copy: `Now let’s define your ICP (ideal customer profile).

Who are you writing for? Be as specific as you like.

This helps Mako tailor your content to maximise engagement.`,
      placeholder: 'Type your ICP here...',
    },
    {
      copy: `The way Mako works is it takes your sites (called ‘inputs’) and crawls them to alert you to new pages posted on these websites.

You can then use this content to create LinkedIn posts.

Add up to 10 inputs below (you should try to add at least 5), and over the next 14 days of your trial, Mako will find any new pages they post, and add them to your ‘feed’. When you are ready, we will take you to your 'feed' to get started.`,
      placeholder: 'Enter a site URL to scan for content',
    }
  ];
  const [dynamicCopy, setDynamicCopy] = useState(stateCopy.map(item => item.copy));

  const handleAdd = async () => {
    if (!input.trim() || inputs.length >= 10) return

    try {
      let parsed = new URL(input.includes('http') ? input : 'https://' + input)
      let hostname = parsed.hostname.replace(/^www\./, '')

      if (!hostname.includes('.')) throw new Error('Invalid domain')

      if (inputs.includes(hostname)) {
        SetIsError(true)
        SetErrorStatus(`You already added ${hostname}`)
        return
      }

      setInputs([...inputs, hostname])
      setInput('')
      SetIsError(false)
    } catch {
      SetIsError(true)
      SetErrorStatus('Please enter a valid URL (e.g. https://example.com)')
    }
  }

  const handleDelete = (urlToRemove) => {
    setInputs(inputs.filter(url => url !== urlToRemove))
  }

  const handleSecondAdd = async () => {
    let createNewPost = await createCustomPostFromURL(SetIsError, SetErrorStatus, input, 'post')
    if (createNewPost) {
      setInput('')
      window.location.href = '/ideas'
    }
  }

  const setTypeAndNext = async (role) => {
    setUserType(role);

    if (prebuiltSites[role]) {
      setInputs(prebuiltSites[role]);
      const updatedCopy = [...dynamicCopy];
      updatedCopy[3] = `The way Mako works is it takes your sites (called ‘inputs’) and crawls them to alert you to new pages posted on these websites.
\n\n
You can then use this content to create LinkedIn posts.
\n\n
Add up to 10 inputs below (you should try to add at least 5), and over the next 14 days of your trial, Mako will find any new pages they post, and add them to your ‘feed’. When you are ready, we will take you to your 'feed' to get started.\n\nWe've added a few sites for you as you are a ${role}.`;
      setDynamicCopy(updatedCopy);
    }

    await updateRole(role); // 🔥 API call
    handleNext();
  };

  const handleBack = () => {
  if (onboardingState > 0) {
    SetOnboardingState(onboardingState - 1);
  }
};



const handleNext = async () => {
  console.log("next");
  console.log(onboardingState);
  console.log(stateCopy.length);
  SetIsError(false);

  if (onboardingState === 1) {
    await updatePersona(persona); // 🔥 API call
  }

  if (onboardingState === 2) {
    await updateICP(icp); // 🔥 API call
  }

  if (onboardingState === 3 && inputs.length > 0) {
    await onboardSites(inputs, SetErrorStatus, SetIsError); // existing
    console.log("should next");
    window.location.href = '/feed';
  }

  if (onboardingState < stateCopy.length - 1) {
    SetOnboardingState(onboardingState + 1);
  }
};

  return (
    <div className='onboarding module p-6 max-w-xl mx-auto text-white font-mono'>
      <h2 className='big-text'>
        Hi, welcome to <span className='highlight-green'>Mako!</span>
      </h2>
<div className='onboarding-progress'>
  <div className='onboarding-progress-bar'>
    <div
      className='onboarding-progress-fill'
      style={{ width: `${((onboardingState) / stateCopy.length) * 100}%` }}
    />
  </div>
</div>


      <div className='mb-4 space-y-4'>
        {dynamicCopy[onboardingState].split('\n\n').map((paragraph, index) => (
          <p key={index}>{paragraph.trim()}</p>
        ))}
      </div>

      {/* Step 0: User type selection */}
      {onboardingState === 0 && (
        <div className='space-y-2'>
          {['Marketer', 'Founder', 'Freelancer', 'Other'].map(role => (
              <div
                type='radio'
                value={role}
                onClick={() => setTypeAndNext(role)}
                className='user-type'
                >
                  {role}
                  </div>
          ))}
        </div>
      )}

      {/* Step 1: Persona input */}
      {onboardingState === 1 && (
        <div className='space-y-4'>
          <textarea
            className='persona-setting'
            value={persona}
            onChange={(e) => setPersona(e.target.value)}
            placeholder={stateCopy[onboardingState].placeholder}
            rows={4}
          />
          <div className='flex gap-2'>
            {onboardingState > 0 && <Button addedFunction={handleBack} text='Back' />}
            <Button addedFunction={handleNext} text='Next' />
          </div>

        </div>
      )}

      {/* Step 2: ICP input */}
      {onboardingState === 2 && (
        <div className='space-y-4'>
          <textarea
            className='persona-setting'
            value={icp}
            onChange={(e) => setICP(e.target.value)}
            placeholder={stateCopy[onboardingState].placeholder}
            rows={4}
          />
          <div className='flex gap-2'>
            {onboardingState > 0 && <Button addedFunction={handleBack} text='Back' />}
            <Button addedFunction={handleNext} text='Next' />
          </div>

        </div>
      )}

      {/* Step 3: Add input sites */}
      {onboardingState === 3 && (
        <>
          <div className='onboarding-url-entry flex gap-2'>
            <input
              type='text'
              value={input}
              onChange={(e) => setInput(e.target.value)}
              className='bg-black text-white border border-gray-600 rounded px-4 py-2 flex-1'
              placeholder={stateCopy[onboardingState].placeholder}
            />
            <Button addedFunction={handleAdd} text='Add site' />
            <div className='flex gap-2'>
              {onboardingState > 0 && <Button addedFunction={handleBack} text='Back' />}
              <Button addedFunction={handleNext} text='Next' />
            </div>

          </div>

          {inputs.length > 0 && (
            <div className='onboarding-site-holder mt-4 space-y-2'>
              {inputs.map((url, index) => (
                <div key={index} className='onboarding-site-entry flex items-center justify-between border border-gray-700 rounded p-2'>
                  <div>{url}</div>
                  <img
                    src='./images/bin.png'
                    alt='delete'
                    className='delete-button cursor-pointer'
                    onClick={() => handleDelete(url)}
                  />
                </div>
              ))}
            </div>
          )}
        </>
      )}

      {isError && (
        <div
          id='error-message'
          className='text-red-500 mt-4'
          dangerouslySetInnerHTML={{
            __html: errorStatus || 'Something went wrong.',
          }}
        />
      )}
    </div>
  )
}

export default Onboarding